import { Stack, useTheme, spacing } from '@fti/design-system';

interface DateInputProps {
  value: string;
  onChange: (date: string) => void;
  label?: string;
}

export function DateInput({ value, onChange, label }: DateInputProps) {
  const { theme } = useTheme();

  return (
    <Stack gap="xs">
      {label && (
        <label
          style={{
            fontSize: '0.85rem',
            fontWeight: 500,
            color: theme.colors.text.primary,
          }}
        >
          {label}
        </label>
      )}
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: `${spacing.xs} ${spacing.sm}`,
          border: `1px solid ${theme.colors.border.default}`,
          borderRadius: '4px',
          backgroundColor: theme.colors.background.paper,
          color: theme.colors.text.primary,
          fontSize: '0.9rem',
        }}
      />
    </Stack>
  );
}
